import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { Search, X } from "lucide-react";

export function AdminFilterBar({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  filters = [],
  activeFilters = [],
  onClearAll,
  extraActions = null,
  searchTestId = "admin-filter-search-input",
}) {
  return (
    <div className="border border-zinc-200 bg-white" data-testid="admin-filter-bar">
      <div className="p-4 border-b border-zinc-200 flex flex-col xl:flex-row gap-3 xl:items-center xl:justify-between">
        <div className="flex-1 flex flex-col md:flex-row gap-3">
          <div className="relative flex-1 min-w-[220px]">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
            <Input
              data-testid={searchTestId}
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder={searchPlaceholder}
              className="pl-9 rounded-md border-zinc-200 focus:border-blue-600 focus:ring-1 focus:ring-blue-600"
            />
          </div>
          <div className="flex flex-wrap gap-3">
            {filters.map((filter) => (
              <Select key={filter.key} value={filter.value} onValueChange={filter.onChange}>
                <SelectTrigger className="w-full md:w-44 rounded-md border-zinc-200" data-testid={filter.testId || `filter-${filter.key}`}>
                  <SelectValue placeholder={filter.label} />
                </SelectTrigger>
                <SelectContent>
                  {filter.options.map((option) => (
                    <SelectItem key={`${filter.key}-${option.value}`} value={option.value}>{option.label}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            ))}
          </div>
        </div>
        {extraActions}
      </div>

      {(activeFilters.length > 0 || onClearAll) && (
        <div className="px-4 py-3 flex flex-wrap items-center gap-2" data-testid="admin-filter-chips">
          {activeFilters.map((filter) => (
            <Badge key={filter.key} variant="outline" className="rounded-full px-3 py-1 text-xs font-medium border-zinc-200 bg-zinc-100 text-zinc-900" data-testid={`active-filter-${filter.key}`}>
              {filter.label}
              {filter.onRemove && (
                <button type="button" onClick={filter.onRemove} className="ml-2 hover:text-red-600" data-testid={`remove-filter-${filter.key}`}>
                  <X className="w-3 h-3" />
                </button>
              )}
            </Badge>
          ))}
          {activeFilters.length > 0 && onClearAll && (
            <Button variant="ghost" size="sm" onClick={onClearAll} className="text-xs uppercase tracking-[0.15em] text-zinc-500" data-testid="clear-all-filters-btn">
              Clear All
            </Button>
          )}
        </div>
      )}
    </div>
  );
}